/**
 * @generated SignedSource<<24dfa22b4670b92ececb5bfaf41328f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type useEditorJsField_data$data = {
  readonly languages: ReadonlyArray<{
    readonly locale: Locale;
  }>;
  readonly " $fragmentType": "useEditorJsField_data";
};
export type useEditorJsField_data$key = {
  readonly " $data"?: useEditorJsField_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorJsField_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useEditorJsField_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Language",
      "kind": "LinkedField",
      "name": "languages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locale",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "62338c0975de8165a7176ca15bdcca59";

export default node;
